module.exports = __webpack_public_path__ + "static/media/omkar_salpekar.8bd04558.jpeg";